





import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsPartsCatalogListItemComponentsLocked extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly inlay: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isCost: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/list/item/components/Locked.vue